import $ from "jquery";
import is from "is_js";

require("jquery-ui/ui/widgets/datepicker.js");
require("jquery-ui/ui/i18n/datepicker-ru.js");


document.addEventListener("DOMContentLoaded", e => {

	// $(".input-date").each((i, el) => {
	// 	let $this = $(el);

	// 	$this.datepicker({
	// 		dateFormat: "dd.mm.yy",
	// 		// changeMonth: true,
	// 		// changeYear: true,
	// 	});
	// });
	
})